module.exports = __webpack_public_path__ + "img/spider-chart.00310577.svg";